import React from 'react';

import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';


const ToggleShowEmail = (props) => {
    const {
        showEmails,
        setShowEmails,
    } = props;

    const handleChange = (event) => {
        setShowEmails(event.target.checked);
    }

    return (
        <div>
            <Switch
                id="reports-show-emails"
                checked={showEmails}
                onChange={handleChange}
                title="Show email addresses"
                color="primary"
            />
            <Typography component="label" className="MuiFormLabel-root MuiInputLabel-shrink">
                Show email addresses
            </Typography>
        </div>
    )
}

export default ToggleShowEmail;
